<ws-ag-grid-angular [gridOptions]="gridOptions"
                    (gridReady)="onAgGridReady($event)"
                    [showConfigureLayout]="false"
                    [forceShowToolPanel]="true">
</ws-ag-grid-angular>
